export const ICONS_5 = [
  "16-ai-action-white",
  "16-calendar-event",
  "16-bubble-wide-annotation-feedback",
  "16-people-added-new-member",
  "16-clock-alert-trial",
  "16-bubble-alert-payment",
  "16-gift",
  "16-shuffle-target-member",
  "16-star-lines-celebrate",
  "16-siren-re-engage",
  "16-bubbles-message",
  "16-calendar-clock-event",
  "16-heart-beat-engagement",
  "16-trending-circle-boost",
  "16-clipboard-feedback",
  "16-bubble-heart",
  "16-group-member",
  "16-tag-comment",
  "16-people-add-bulk",
  "16-square-behind-square-clone",
  "16-people-remove",
  "16-raising-hand-greet",
  "16-page-check-form",
  "16-target-arrow-tag",
  "16-credit-card",
  "16-hourglass",
  "16-coin-dollar",
  "16-thumbs-up-2",
  "16-trophy",
  "16-fork-code",
  "16-page-check",
  "16-rejected-comment",
  "16-square-arrow-top-right",
  "16-settings-gear",
  "20-user-add",
  "20-ai-filter",
  "12-ai-filter",
  "20-open-quote",
  "16-ai-rename",
  "16-lightning-filled",
  "16-branded-apps-builder-preview-circle",
  "24-builder-ui-element-line",
  "16-builder-ui-layers-chevron",
  "20-ai-prompt",
  "24-logo",
  "20-triangle-exclamation",
  "hw-help-submit-enabled-dark-mode",
  "hw-help-submit-disabled-dark-mode",
  "sw-help-submit-enabled",
  "sw-help-submit-disabled",
  "16-square-arrow-down",
  "20-visibility-visible",
  "20-visibility-hidden",
  "16-ai-send-dm",
  "24-layers-2",
  "24-layers-2-filled",
  "24-builder-element-grid",
  "24-builder-element-section",
  "16-alignment-left",
  "16-alignment-center",
  "16-alignment-right",
  "20-alignment-left",
  "20-alignment-center",
  "20-alignment-right",
  "16-settings-slider",
  "20-settings-slider",
  "visual-email-builder-dark",
  "visual-email-builder",
  "text-email-builder-dark",
  "text-email-builder",
  "12-play",
  "16-crown",
  "live-picture-in-picture",
  "64-picture-in-picture",
  "16-star-lines",
  "16-checklist",
  "16-rename",
  "copilot-chain-link",
  "20-chart",
  "20-tags",
  "20-no-tags",
  "16-brackets-2",
  "24-arrow-up",
  "24-arrow-down",
  "20-align-object-left",
  "20-align-object-center",
  "20-align-object-right",
  "20-zap",
  "16-hw-paperclip",
  "paywalls-card-amex",
  "paywalls-card-diners",
  "paywalls-card-discover",
  "paywalls-card-generic",
  "paywalls-card-jcb",
  "paywalls-card-mastercard",
  "paywalls-card-unionpay",
  "paywalls-card-visa",
  "paywalls-affirm",
  "paywalls-afterpay",
  "paywalls-apple-pay",
  "paywalls-bancontact",
  "paywalls-google-pay",
  "paywalls-ideal",
  "paywalls-klarna",
  "paywalls-link",
  "paywalls-pix",
  "paywalls-sepa-debit",
  "16-close-rounded",
  "16-blockquote",
  "20-arrow-up-down",
  "20-layout",
  "20-lock",
  "20-group",
  "20-globe-v2",
  "20-list",
  "20-cards",
  "live-pip-speaker-mode",
  "live-pip-gallery-mode",
  "20-hw-copilot-thinking-star",
  "24-builder-ui-element-short-answer",
  "24-builder-ui-element-long-answer",
  "24-builder-ui-element-single-choice",
  "24-builder-ui-element-multiple-choice",
  "20-eye-open",
  "20-dm-message",
  "20-moderator",
  "20-block-dms",
  "16-circle-x",
  "16-warning",
  "hw-copy",
  "hw-copied",
  "hw-up-vote",
  "hw-up-voted",
  "hw-down-vote",
  "hw-down-voted",
  "hw-sources",
];
